export default __webpack_public_path__ + "static/ania_rubkiewicz-1b975c33a4efe445f099f65ca3ff8f75.jpeg";